import { LocalDataSetup } from "pouchDB/LocalDataSetup";
// import { MasterSync } from "MasterSync";
import { api_link } from "siteConfig";
import axios from "axios";
const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds

export const CompleteJob = async (job, timeon, timeoff, workreport, quotereq, quotedetails, revisitdetails, revisitreq, visitdate) => {

    timeon = timeon.replace('T', ' ').replace('Z', '');
    timeoff = timeoff.replace('T', ' ').replace('Z', '');

    let db_jobs_local = LocalDataSetup.db_jobs_local;
    let url = 'https://'+api_link+'supplier_portal/rabbitmq/complete_job'

    quotereq = quotereq === true ? "1" : "0"
    revisitreq = revisitreq === true ? "1" : "0"

    db_jobs_local.get(job.JobID+'*'+job.SessionID).then(function (doc) {
        doc.job.Status = 800;
        doc.job.TimeOff1 = timeoff;
        doc.job.TimeOn1 = timeon;
        doc.job.WorkReport = workreport;
        doc.job.QuoteRequired = quotereq;
        doc.job.QuoteDetails = quotedetails;
        doc.job.RevisitRequired = revisitreq;
        doc.job.RevisitDetails = revisitdetails;
        doc.job.StatusDesc = 'Completed';
        if(visitdate) {
            doc.job.VisitDate = visitdate;
        }

        let eta = doc.job.ArrivalTimeEstimated

        axios({
            method: "post",
            url: url,
            data: {
                "referurl": url,
                "var1": doc.job.JobID,
                "var2": doc.job.SessionID,
                "var3": eta,
                "var4": timeon,
                "var5": timeoff,
                "var6": workreport,
                "var7": quotereq,
                "var8": quotedetails,
                "var9": revisitreq,
                "var10": revisitdetails,
                "var11": visitdate
            },
            headers: {
                "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                "Content-Type": "application/json"
            }
        }).then(resp => {
        }).catch(err => {
            console.log(err)
        })
        // Save changes to db
        db_jobs_local.put(doc).then(function () {
            console.log('Job updated in db (CompleteJob)');
        }).catch(function (err) {
            console.log('Error updating job in db (CompleteJob):', err);
        });

    }).catch(function (err) {
        console.log(err);
    });

    // return updated job
    job.Status = 800;
    job.TimeOff1 = timeoff;
    job.TimeOn1 = timeon;
    job.WorkReport = workreport;
    job.QuoteRequired = quotereq;
    job.QuoteDetails = quotedetails;
    job.RevisitRequired = revisitreq;
    job.RevisitDetails = revisitdetails;
    job.StatusDesc = 'Completed';
    if(visitdate) {
        job.VisitDate = visitdate;
    }

    return job;
}

export const ArriveOnSite = async (job) => {
    let db_jobs_local = LocalDataSetup.db_jobs_local;
    let url = 'https://'+api_link+'supplier_portal/rabbitmq/arrive_on_site'

    //get time now
    let now = new Date(Date.now() - tzoffset);
    let timeon = now.toISOString().replace('T', ' ').replace('Z', '');
    
    db_jobs_local.get(job.JobID+'*'+job.SessionID).then(function (doc) {
        doc.job.Status = 400;
        doc.job.TimeOn1 = timeon;
        doc.job.StatusDesc = 'On Site';

        axios({
            method: "post",
            url: url,
            data: {
                "referurl": url,
                "var1": doc.job.JobID,
                "var2": doc.job.SessionID,
                "var3": timeon
            },
            headers: {
                "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                "Content-Type": "application/json"
            }
        }).then(resp => {
        }).catch(err => {
            console.log(err)
        })
        // Save changes to db
        db_jobs_local.put(doc).then(function () {
            console.log('Job updated in db (ArriveOnSite)');
        }).catch(function (err) {
            console.log('Error updating job in db (ArriveOnSite):', err);
        });

    }).catch(function (err) {
        console.log(err);
    });

    // return updated job
    job.Status = 400;
    job.TimeOn1 = timeon;
    job.StatusDesc = 'On Site';

    return job;
}

export const StartTravel = async (job, eta) => {
    let db_jobs_local = LocalDataSetup.db_jobs_local;
    let url = 'https://'+api_link+'supplier_portal/rabbitmq/start_travel'
    
    await checkOnJob().then(function (onJob) {
        if(onJob) {
            eta = eta.replace('T', ' ');
            eta = eta.replace('Z', '');
            
            db_jobs_local.get(job.JobID+'*'+job.SessionID).then(function (doc) {
                doc.job.Status = 300;
                doc.job.ArrivalTimeEstimated = eta;
                doc.job.StatusDesc = 'En-Route';
                
                // fire off the request to rabbitmq
                axios({
                    method: "post",
                    url: url,
                    data: {
                        "referurl": url,
                        "var1": doc.job.JobID,
                        "var2": doc.job.SessionID,
                        "var3": eta
                    },
                    headers: {
                        "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                        // "Access-Control-Allow-Origin": "*",
                        "Content-Type": "application/json"
                    }
                }).then(resp => {
                }).catch(err => {
                    console.log(err)
                })
                // Save changes to db
                db_jobs_local.put(doc).then(function () {
                    console.log('Job updated in db (StartTravel)');
                }).catch(function (err) {
                    console.log('Error updating job in db (StartTravel):', err);
                })

                

            }).catch(function (err) {
                console.log(err);
            });

            // return updated job
            job.Status = 300;
            job.ArrivalTimeEstimated = eta;
            job.StatusDesc = 'En-Route';
        }
        else {
            console.log('Cannot start travel while on another job.');
            window.alert('Cannot start travel while on another job.');
        }
    });

    return job;
}

export const CancelArrival = async (job) => {
    let db_jobs_local = LocalDataSetup.db_jobs_local;
    
    db_jobs_local.get(job.JobID+'*'+job.SessionID).then(function (doc) {
        doc.job.Status = 300;
        doc.job.TimeOn1 = '';
        doc.job.StatusDesc = 'En-Route';
        db_jobs_local.put(doc).then(function () {
            console.log('Job Status Changed to 300');
        }).catch(function (err) {
            console.log(err);
        });
    }).catch(function (err) {
        console.log(err);
    });

    // return updated job
    job.Status = 300;
    job.TimeOn1 = '';
    job.StatusDesc = 'En-Route';

    return job;
}

export const CancelTravel = async (job) => {
    let db_jobs_local = LocalDataSetup.db_jobs_local;
    
    db_jobs_local.get(job.JobID+'*'+job.SessionID).then(function (doc) {
        doc.job.Status = 250;
        doc.job.ArrivalTimeEstimated = '';
        doc.job.StatusDesc = 'Allocated';
        db_jobs_local.put(doc).then(function () {
            console.log('Job Status Changed to 250');
        }).catch(function (err) {
            console.log(err);
        });
    }).catch(function (err) {
        console.log(err);
    });

    // return updated job
    job.Status = 250;
    job.ArrivalTimeEstimated = '';
    job.StatusDesc = 'Allocated';

    return job;
}

export const OnlineCheck = async () => {

    //ping a website to check online status
    const url = 'https://www.google.com';
    let online = false;

    await fetch(url, {mode: 'no-cors'}).then(() => {
        online = true;
    }).catch(() => {
        online = false;
    });

    return online;

}

async function checkOnJob() {
    let db_jobs_local = LocalDataSetup.db_jobs_local;
    let login_role = sessionStorage.getItem("role");

    console.log('Checking if on another job...');

    if(login_role === 'Office') {
        return true;
    }
    else {
        // check for a job that is in progress using the status
        console.log('Engineer logon, checking for job status...');

        return await db_jobs_local.allDocs({
            include_docs: true,
            attachments: true
        }).then(function (result) {
            let onJob = true;

            result.rows.forEach(function (row) {
                let job = row.doc.job;

                console.log('Checking Job: ' + job.JobID + ' - ' + parseInt(job.Status));

                if(parseInt(job.Status) >= 300) {
                    if(parseInt(job.Status) < 600) {
                        console.log('Active Job Found: ' + job.JobID);
                        onJob = false;
                    }
                }
            });

            console.log('On Job: ' + onJob);

            return onJob;
        }).catch(function (err) {
            console.log(err);
        });

        // return onJob;
    }
}